import trendingTopic from './trending-topic'
import trendSummary from './trend-summary'
import { TREND_SUMMARIES, TRENDCALLS, TRENDING_TOPICS } from '@/model/views/tabs'

export default {
    trendingTopic,
    trendSummary,

    pageTitle: {
        [TRENDCALLS]: 'INSIGHTS - TRENDCALLS',
        [TRENDING_TOPICS]: 'INSIGHTS - TRENDING TOPICS',
        [TREND_SUMMARIES]: 'INSIGHTS - TREND SUMMARIES'
    }
}
